import { Backlink, Box, Pagesection } from '@ktag/styleguide/dist/react';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ErrorMessage = () => {
  const { t } = useTranslation('wap');

  const { pathname } = useLocation();
  const isArchive = pathname.includes('archiv');
  const isSubPage = pathname.includes('vorlage');

  let translationKey: string;

  if (isArchive) {
    translationKey = 'error_message_archive';
  } else if (isSubPage) {
    translationKey = 'error_message_sub_page';
  } else {
    translationKey = 'error_message_start_page';
  }

  return (
    <>
      {(isSubPage || isArchive) && (
        <Pagesection>
          <Backlink text={t('not_found_back')} url="#" />
        </Pagesection>
      )}
      <Pagesection>
        <Box heading={t('error_heading')}>{t(translationKey)}</Box>
      </Pagesection>
    </>
  );
};

export default ErrorMessage;
